import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Checks if the token is valid and gets the user info contained in it.
 */
export const getAuthInfo = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/token`)
})
